module.exports = __webpack_public_path__ + "img/app-google.4473b0b8.svg";